import { motion } from "framer-motion";
import { FadeIn } from "@/components/animated";
import { Building2 } from "lucide-react";

// SVG logos for trusted companies (inline for reliability)
const companyLogos = [
  { name: "Google", color: "#4285F4" },
  { name: "Microsoft", color: "#00A4EF" },
  { name: "Amazon", color: "#FF9900" },
  { name: "Meta", color: "#0081FB" },
  { name: "Apple", color: "#555555" },
  { name: "Spotify", color: "#1DB954" },
];

export function TrustBadges() {
  return (
    <section className="py-12 bg-white border-y border-secondary-100">
      <div className="container">
        <FadeIn>
          <p className="text-center text-sm font-medium text-secondary-500 uppercase tracking-wider mb-8">
            Nuestros estudiantes trabajan en empresas líderes
          </p>
        </FadeIn>

        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 lg:gap-16">
          {companyLogos.map((company, index) => (
            <motion.div
              key={company.name}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="trust-badge flex items-center gap-2"
            >
              <Building2
                className="h-6 w-6 md:h-7 md:w-7"
                style={{ color: company.color }}
              />
              <span
                className="text-lg md:text-xl font-semibold"
                style={{ color: company.color }}
              >
                {company.name}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
